import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Grid,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    paddingTop: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      textAlign: props.textAlign ? props.textAlign : 'left',
    },
  }),
}));

const OneCol = (props) => {
  const {
    justify = 'flex-start',
    span = 6,
    col,
    textAlign,
  } = props;

  const classes = useStyles({ textAlign });

  return (
    <Grid
      container
      spacing={4}
      justify={justify}
      className={classes.root}
    >
      <Grid
        item
        xs={12}
        md={span}
      >
        <Box>
          {col}
        </Box>
      </Grid>
    </Grid>
  );
};

OneCol.defaultProps = {
  justify: 'flex-start',
  span: 6,
  textAlign: 'left',
};

OneCol.propTypes = {
  justify: PropTypes.string,
  span: PropTypes.number,
  col: PropTypes.element.isRequired,
  textAlign: PropTypes.string,
};

export default OneCol;
